import type { DbThemeConfig } from './theme.types';

export const defaultTheme: DbThemeConfig = {
    colors: {
        primary: '#007AFF',
        secondary: '#8E8E93',
        success: '#34C759',
        warning: '#FF9500',
        error: '#FF3B30',
        info: '#5AC8FA',

        background: '#FFFFFF',
        surface: '#F2F2F7',

        text: '#000000',
        textSecondary: '#8E8E93',
        textDisabled: '#C7C7CC',
        textInverse: '#FFFFFF',

        border: '#E5E7EB',
        divider: '#EBEDF0',
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 16,
        lg: 24,
        xl: 32,
        xxl: 48,
    },
    borderRadius: {
        small: 4,
        medium: 8,
        large: 12,
        xl: 16,
        full: 9999,
    },
    interaction: {
        activeOpacity: 0.7,
        activeOpacityHigh: 0.5,
        activeOpacityLow: 0.9,
        disabledOpacity: 0.5,
    },
    navBar: {
        useLinearGradient: true,
        gradientColors: ['#fe8491', '#fda1a6', '#f8b7b1'],
        backgroundColor: '#FFFFFF',
        titleColor: '#333333',
        useTheme: true,
    },
};

/**
 * 辅助函数：获取点击透明度
 * @param theme 主题配置
 * @param intensity 强度级别：'default' | 'high' | 'low'
 * @returns 透明度值 (0-1)
 */
export const getActiveOpacity = (
    theme: { interaction: { activeOpacity: number; activeOpacityHigh: number; activeOpacityLow: number } },
    intensity: 'default' | 'high' | 'low' = 'default'
): number => {
    switch (intensity) {
        case 'high':
            return theme.interaction.activeOpacityHigh;
        case 'low':
            return theme.interaction.activeOpacityLow;
        default:
            return theme.interaction.activeOpacity;
    }
};